export default __webpack_public_path__ + "images/da8f6a6d2ccaacbbeffe53e1909c076f.png";